import styles from "./TabPanel.module.scss";

interface ITabPanel {
  children: React.ReactNode;
}
const TabPanel = ({ children }: ITabPanel) => {
  return <section className={styles.tabPanel}>{children}</section>;
};

export default TabPanel;
